/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientBehaviorReplacementModel } from '../../models/patient-behavior-replacement-model';

export interface GetPatientBehaviorReplacements$Params {
  patientID?: number;
  onlyActive?: boolean;
}

export function GetPatientBehaviorReplacements(http: HttpClient, rootUrl: string, params?: GetPatientBehaviorReplacements$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PatientBehaviorReplacementModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientBehaviorReplacements.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('onlyActive', params.onlyActive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PatientBehaviorReplacementModel>>;
    })
  );
}

GetPatientBehaviorReplacements.PATH = '/api/Staff/GetPatientBehaviorReplacements';
